var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"te-header fixed-top border-bottom co-border-gray-5 co-bg-white-1"},[_c('div',{staticClass:"navbar navbar-expand-lg co-container-lg co-px-16 co-py-0"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between w-100 co-w-lg-auto",staticStyle:{"height":"70px"}},[_c('BuCommonHeaderLogo')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }